import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "stroke-width"]
const _hoisted_2 = ["d"]


export default /*@__PURE__*/_defineComponent({
  __name: 'StudioIcon',
  props: {
    name: {},
    size: { default: 18 }
  },
  setup(__props: any) {


const paths = {
  file: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6",
  search: "M21 21l-5-5 M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0",
  plus: "M12 5v14 M5 12h14",
  more: "M5 12h.01 M12 12h.01 M19 12h.01",
  trash: "M3 6h18 M9 6V3h6v3 M5 6l1 15h12l1-15 M10 10v7 M14 10v7",
  folder: "M3 7V5a2 2 0 0 1 2-2h5l2 3h7a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
  undo: "M3 10h8a7 7 0 0 1 7 7v2 M3 10l5-5 M3 10l5 5",
  redo: "M21 10h-8a7 7 0 0 0-7 7v2 M21 10l-5-5 M21 10l-5 5",
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": __props.name === 'more' ? 3.5 : 1.7,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true"
  }, [
    _createElementVNode("path", {
      d: paths[__props.name]
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})